export const launcherElementTypes = [
  'div',
  'button',
  'text',
  'link',
  'variableText',
  'img',
  'appTaskProgressBar',
  'appTaskProgressBarFill',
  'iframe',
  'popup',
  // TODO: add back
  // 'licensePopup',
  // 'targetVariableInput',
  // 'appChangelog'
] as const;

export type LauncherElementType = typeof launcherElementTypes[number];

export type LauncherElementPropInput =
  // Variables Panel
  | 'windowHandleVariableInput'
  | 'commandVariableInput'
  | 'textVariableInput'
  | 'hrefVariableInput'
  | 'variableTextVariableInput'
  | 'srcVariableInput'
  | 'allowFullscreenVariableInput'
  | 'targetVariableInput'
  // Container Panel
  | 'positionInput'
  | 'sizeInput'
  | 'positioningInput'
  | 'positioningSimplifiedInput'
  | 'paddingInput'
  | 'marginInput'
  | 'gapInput'
  | 'overflowInput'
  // Text Panel
  | 'textInput'
  // Style Panel
  | 'textComboInput'
  | 'containerComboInput'
  | 'effectComboInput';

export const variableInputs = [
  'windowHandleVariableInput',
  'commandVariableInput',
  'textVariableInput',
  'hrefVariableInput',
  'variableTextVariableInput',
  'srcVariableInput',
  'allowFullscreenVariableInput',
  // TODO: add back
  // 'targetVariableInput'
] as LauncherElementPropInput[];
export const containerInputs = [
  'positionInput',
  'sizeInput',
  'positioningInput',
  'positioningSimplifiedInput',
  'paddingInput',
  'marginInput',
  'gapInput',
  'overflowInput',
] as LauncherElementPropInput[];
export const styleInputs = ['textComboInput', 'containerComboInput', 'effectComboInput'] as LauncherElementPropInput[];

type LauncherElementInfo = {
  [key in LauncherElementType]: {
    id?: string;
    name?: string;
    iconClassName: string;
    HTMLTagName: string;
    commands?: { [key: string]: string };
    variables?: { [key: string]: string };
    targetVariables?: { [key: string]: string };
    variablesDefault?: { [key: string]: string };
    defaultProps?: { [key: string]: any };
    propInputs?: LauncherElementPropInput[];
  };
};

export const launcherElementInfo: LauncherElementInfo = {
  div: {
    name: 'Box',
    iconClassName: 'icon-box',
    HTMLTagName: 'div',
    defaultProps: {
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        width: '200px',
        height: '200px',
        background: '#dddddd80',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      children: [],
    },
    propInputs: [
      // Variables Panel
      'windowHandleVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningInput',
      'paddingInput',
      'marginInput',
      'gapInput',
      'overflowInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  button: {
    name: 'Button',
    iconClassName: 'icon-button',
    HTMLTagName: 'div',
    commands: {
      minimizeWindowCommand: 'Window - Minimize',
      hideWindowCommand: 'Window - Close',
      maximizeOrRestoreWindowCommand: 'Window - Maximize/Restore',

      submitAppLicenseKeyCommand: 'App - Submit License Key',
      startAppInstallTaskCommand: 'App - Install',
      cancelAppInstallTaskCommand: 'App - Cancel Installation',
      pauseAppInstallTaskCommand: 'App - Pause Installation',
      resumeAppInstallTaskCommand: 'App - Resume Installation',
      chooseAppPathCommand: 'App - Choose Path',
      startAppCommand: 'App - Start',
      startAppUninstallTaskCommand: 'App - Uninstall',
      startAppUpdateTaskCommand: 'App - Update',
      pauseAppUpdateTaskCommand: 'App - Pause Update',
      resumeAppUpdateTaskCommand: 'App - Resume Update',
      startAppRepairTaskCommand: 'App - Repair',
      pauseAppRepairTaskCommand: 'App - Pause Repair',
      resumeAppRepairTaskCommand: 'App - Resume Repair',

      openExternalLinkCommand: 'Link - Open External',

      openPopupCommand: 'Popup - Open',
      closePopupCommand: 'Popup - Close',
      togglePopupCommand: 'Popup - Toggle',

    },
    defaultProps: {
      commands: [{ type: 'startAppCommand' }],
      class: {
        boxSizing: 'border-box',
        cursor: 'pointer',
        position: 'absolute',
        top: '100px',
        left: '100px',
        width: '200px',
        height: '200px',
        background: '#00000080',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      children: [],
    },
    propInputs: [
      // Variables Panel
      'commandVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningInput',
      'paddingInput',
      'marginInput',
      'gapInput',
      'overflowInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  text: {
    name: 'Text',
    iconClassName: 'icon-text',
    HTMLTagName: 'span',
    defaultProps: {
      text: 'Text',
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        whiteSpace: 'pre-wrap',
      },
    },
    propInputs: [
      // Variables Panel
      'textVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningSimplifiedInput',
      'paddingInput',
      'marginInput',
      'overflowInput',
      // Text Panel
      'textInput',
      // Style Panel
      'textComboInput',
      'containerComboInput',
      'effectComboInput',
    ],
  },
  link: {
    name: 'Link',
    iconClassName: 'icon-hyperlink',
    HTMLTagName: 'a',
    defaultProps: {
      text: 'Link',
      href: 'https://www.example.com',
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        whiteSpace: 'pre-wrap',
      },
    },
    propInputs: [
      // Variables Panel
      'textVariableInput',
      'hrefVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningSimplifiedInput',
      'paddingInput',
      'marginInput',
      'overflowInput',
      // Text Panel
      'textInput',
      // Style Panel
      'textComboInput',
      'containerComboInput',
      'effectComboInput',
    ],
  },
  variableText: {
    name: 'Variable Text',
    iconClassName: 'icon-variable',
    HTMLTagName: 'span',
    variables: {
      appName: 'App Name',
      appDescription: 'App Description',
      appVersionLabel: 'App Version Label',
      appTaskOperationName: 'Task Operation Name',
      appTaskPackageSize: 'Task Package Size',
      appTaskDownloadedSize: 'Task Downloaded Size',
      appTaskDownloadSpeed: 'Task Download Speed',
      appTaskPercentage: 'Task Percentage',
      appInstallPath: 'App Install Path',
      appInstallPackageSize: 'App Install Package Size',
      appUpdatePackageSize: 'App Update Package Size',
      // TODO: add back
      // appLicenseKeyErrorMessage: 'App License Key Error Message', 
      // appChangelogEntryLabel: 'Changelog Entry Label', 
      // appChangelogEntryDateTime: 'Changelog Entry DateTime', 
      // appChangelogEntryContent: 'Changelog Entry Content', 
    },
    variablesDefault: {
      appName: '[App Name]',
      appDescription: '[App Description]',
      appVersionLabel: 'v1.0.0',
      appTaskOperationName: '[Operation Name]',
      appTaskPackageSize: '-',
      appTaskDownloadedSize: '-',
      appTaskDownloadSpeed: '0KB/s',
      appTaskPercentage: '[Task Percentage]',
      appInstallPath: 'C:\\Program Files\\Games\\app',
      appInstallPackageSize: '[Install Size]',
      appUpdatePackageSize: '[Update Size]',
      // TODO: add back
      // appLicenseKeyErrorMessage: '[Error Message]',
      // appChangelogEntryLabel: '1.0.0',
      // appChangelogEntryDateTime: '2024-01-01 13:50',
      // appChangelogEntryContent: '[Changelog Entry Content]',
    },
    defaultProps: {
      variable: 'appName',
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        whiteSpace: 'pre-wrap'
      },
    },
    propInputs: [
      // Variables Panel
      'variableTextVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningSimplifiedInput',
      'paddingInput',
      'marginInput',
      'overflowInput',
      // Text Panel
      'textInput',
      // Style Panel
      'textComboInput',
      'containerComboInput',
      'effectComboInput',
    ],
  },
  img: {
    name: 'Image',
    iconClassName: 'icon-img',
    HTMLTagName: 'img',
    defaultProps: {
      src: 'https://picsum.photos/id/634/600/600',
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
      },
    },
    propInputs: [
      // Variables Panel
      'srcVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'marginInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  appTaskProgressBar: {
    name: 'Progress Bar',
    iconClassName: 'icon-progressbar',
    HTMLTagName: 'div',
    defaultProps: {
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        width: '200px',
        height: '20px',
        background: '#00000080',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px',
      },
      children: [
        {
          type: 'appTaskProgressBarFill',
          name: 'Progress Bar Fill',
          iconClassName: 'icon-progressbar',
          HTMLTagName: 'div',
          props: {
            class: {
              boxSizing: 'border-box',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '40%',
              height: '100%',
              background: '#33c8db',
            },
          },
        },
      ],
    },
    propInputs: [
      // Variables Panel
      'windowHandleVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningInput',
      'paddingInput',
      'marginInput',
      'gapInput',
      'overflowInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  appTaskProgressBarFill: {
    name: 'Progress Bar Fill',
    iconClassName: 'icon-progressbar',
    HTMLTagName: 'div',
    defaultProps: {
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '40%',
        height: '100%',
      },
    },
    propInputs: [
      // Container Panel
      'positionInput',
      'sizeInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  iframe: {
    name: 'Iframe',
    iconClassName: 'icon-iframe',
    HTMLTagName: 'iframe',
    defaultProps: {
      src: 'https://www.example.com',
      allowFullScreen: true,
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '100px',
        left: '100px',
        width: '300px',
        height: '200px',
        border: 'none',
      },
    },
    propInputs: [
      // Variables Panel
      'srcVariableInput',
      'allowFullscreenVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'marginInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  popup: {
    name: 'Popup',
    iconClassName: 'icon-popup',
    HTMLTagName: 'div',
    defaultProps: {
      class: {
        boxSizing: 'border-box',
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',

        display: 'none',
        '&[popup-open]': {
          display: 'flex',
        },
      },
      children: [
        {
          type: 'button',
          name: 'Popup Background',
          iconClassName: 'icon-box',
          HTMLTagName: 'div',
          props: {
            class: {
              boxSizing: 'border-box',
              position: 'absolute',
              width: '100%',
              height: '100%',
              background: '#000000b3',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backdropFilter: 'blur(2px)',
            },
            children: [],
          },
        },
        {
          type: 'div',
          name: 'Popup Content',
          iconClassName: 'icon-box',
          HTMLTagName: 'div',
          props: {
            class: {
              boxSizing: 'border-box',
              position: 'relative',
              width: '500px',
              height: '300px',
              background: '#111',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
            children: [],
          },
        },
      ],
    },
    propInputs: [
      // Variables Panel
      'windowHandleVariableInput',
      // Container Panel
      'positionInput',
      'sizeInput',
      'positioningInput',
      'paddingInput',
      'marginInput',
      'gapInput',
      'overflowInput',
      // Style Panel
      'containerComboInput',
      'effectComboInput',
    ],
  },
  // TODO: add back
  // licensePopup: {
  //   id: 'appLicenseKeyPopup',
  //   name: 'License Popup',
  //   iconClassName: 'icon-license-popup',
  //   HTMLTagName: 'div',
  //   defaultProps: {
  //     class: {
  //       boxSizing: 'border-box',
  //       position: 'absolute',
  //       top: '0px',
  //       left: '0px',
  //       width: '100%',
  //       height: '100%',
  //       flexDirection: 'column',
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //       gap: '15px',
  //       background: '#111',

  //       display: 'none',
  //       '&[popup-open]': {
  //         display: 'flex',
  //       },
  //     },
  //     children: [
  //       {
  //         type: 'text',
  //         name: 'Title',
  //         iconClassName: 'icon-text',
  //         HTMLTagName: 'span',
  //         props: {
  //           text: 'Enter License Key',
  //           class: {
  //             position: 'relative',
  //             boxSizing: 'border-box',
  //             fontSize: '20px',
  //           }
  //         }
  //       },
  //       {
  //         type: 'targetVariableInput',
  //         name: 'Input',
  //         iconClassName: 'icon-focus',
  //         HTMLTagName: 'input',
  //         props: {
  //           targetVariable: 'appLicenseKey',
  //           class: {
  //             position: 'relative',
  //             boxSizing: 'border-box',
  //             fontSize: '14px',
  //             padding: '5px',
  //             borderRadius: '5px',
  //             width: '300px',
  //             background: '#222',
  //             color: '#fff',
  //             outline: 'none',
  //             borderTopWidth: "1px",
  //             borderTopStyle: "solid",
  //             borderTopColor: "#222",
  //             borderBottomWidth: "1px",
  //             borderBottomStyle: "solid",
  //             borderBottomColor: "#222",
  //             borderLeftWidth: "1px",
  //             borderLeftStyle: "solid",
  //             borderLeftColor: "#222",
  //             borderRightWidth: "1px",
  //             borderRightStyle: "solid",
  //             borderRightColor: "#222",
  //             textAlign: 'center',
  //             ['&:focus']: {
  //               borderTopWidth: "1px",
  //               borderTopStyle: "solid",
  //               borderTopColor: "#333",
  //               borderBottomWidth: "1px",
  //               borderBottomStyle: "solid",
  //               borderBottomColor: "#333",
  //               borderLeftWidth: "1px",
  //               borderLeftStyle: "solid",
  //               borderLeftColor: "#333",
  //               borderRightWidth: "1px",
  //               borderRightStyle: "solid",
  //               borderRightColor: "#333",
  //             }
  //           }
  //         }
  //       },
  //       {
  //         type: 'variableText',
  //         name: 'License Key Error Message',
  //         iconClassName: 'icon-text',
  //         HTMLTagName: 'span',
  //         props: {
  //           variable: 'appLicenseKeyErrorMessage',
  //           class: {
  //             position: 'relative',
  //             boxSizing: 'border-box',
  //             fontSize: '14px',
  //             color: '#dd0000',
  //           }
  //         }
  //       },
  //       {
  //         type: 'button',
  //         name: 'Submit',
  //         iconClassName: 'icon-button',
  //         HTMLTagName: 'button',
  //         props: {
  //           commands: [{ type: 'submitAppLicenseKeyCommand' }],
  //           class: {
  //             position: 'relative',
  //             boxSizing: "border-box",
  //             cursor: "pointer",
  //             width: "150px",
  //             height: "35px",
  //             background: "#222",
  //             borderRadius: "10px",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             ['&:hover']: {
  //               background: "#333",
  //             }
  //           },
  //           children: [
  //             {
  //               type: 'text',
  //               name: 'Submit',
  //               iconClassName: 'icon-text',
  //               HTMLTagName: 'span',
  //               props: {
  //                 text: 'Submit'
  //               }
  //             }
  //           ]
  //         }
  //       },
  //     ],
  //   },
  //   propInputs: [
  //     // Variables Panel
  //     'windowHandleVariableInput',
  //     // Container Panel
  //     'positionInput',
  //     'sizeInput',
  //     'positioningInput',
  //     'paddingInput',
  //     'marginInput',
  //     'gapInput',
  //     'overflowInput',
  //     // Style Panel
  //     'containerComboInput',
  //     'effectComboInput',
  //   ],
  // },
  // targetVariableInput: {
  //   name: 'Input',
  //   iconClassName: 'icon-focus',
  //   HTMLTagName: 'input',
  //   defaultProps: {
  //     targetVariable: 'appLicenseKey',
  //     class: {
  //       position: 'relative',
  //       boxSizing: 'border-box',
  //       fontSize: '14px',
  //       padding: '5px',
  //       borderRadius: '5px',
  //       width: '300px',
  //       background: '#222',
  //       color: '#fff',
  //       outline: 'none',
  //       borderTopWidth: "1px",
  //       borderTopStyle: "solid",
  //       borderTopColor: "#222",
  //       borderBottomWidth: "1px",
  //       borderBottomStyle: "solid",
  //       borderBottomColor: "#222",
  //       borderLeftWidth: "1px",
  //       borderLeftStyle: "solid",
  //       borderLeftColor: "#222",
  //       borderRightWidth: "1px",
  //       borderRightStyle: "solid",
  //       borderRightColor: "#222",
  //       textAlign: 'center',
  //       ['&:focus']: {
  //         borderTopWidth: "1px",
  //         borderTopStyle: "solid",
  //         borderTopColor: "#333",
  //         borderBottomWidth: "1px",
  //         borderBottomStyle: "solid",
  //         borderBottomColor: "#333",
  //         borderLeftWidth: "1px",
  //         borderLeftStyle: "solid",
  //         borderLeftColor: "#333",
  //         borderRightWidth: "1px",
  //         borderRightStyle: "solid",
  //         borderRightColor: "#333",
  //       }
  //     }
  //   },
  //   targetVariables: {
  //     appLicenseKey: 'App License Key',
  //   },
  //   propInputs: [
  //     // Variables Panel
  //     'targetVariableInput',
  //     // Container Panel
  //     'positionInput',
  //     'sizeInput',
  //     'positioningSimplifiedInput',
  //     'paddingInput',
  //     'marginInput',
  //     'overflowInput',
  //     // Text Panel
  //     'textInput',
  //     // Style Panel
  //     'textComboInput',
  //     'containerComboInput',
  //     'effectComboInput',
  //   ],
  // },
  // appChangelog: {
  //   name: 'App Changelog',
  //   iconClassName: 'icon-changelog',
  //   HTMLTagName: 'div',
  //   defaultProps: {
  //     class: {
  //       boxSizing: "border-box",
  //       position: "relative",
  //       width: "300px",
  //       height: "300px",
  //       background: "#11111155",
  //       display: "flex",
  //       justifyContent: "flex-start",
  //       alignItems: "center",
  //       borderRadius: "10px",
  //       overflow: "auto",
  //       overflowX: "hidden",
  //       flexDirection: "column",
  //     },
  //     children: [
  //       {
  //         name: 'Changelog Entry',
  //         type: 'div',
  //         props: {
  //           class: {
  //             boxSizing: "border-box",
  //             position: "relative",
  //             width: "100%",
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "flex-start",
  //             flexDirection: "column"
  //           },
  //           children: [
  //             {
  //               type: 'variableText',
  //               name: 'Changelog Entry Label',
  //               props: {
  //                 variable: 'appChangelogEntryLabel',
  //                 class: {
  //                   position: "relative",
  //                   fontSize: "20px",
  //                   paddingTop: "5px",
  //                   whiteSpace: "pre-wrap"
  //                 }
  //               },
  //             },
  //             {
  //               type: 'variableText',
  //               name: 'Changelog Entry DateTime',
  //               props: {
  //                 variable: 'appChangelogEntryDateTime',
  //                 class: {
  //                   position: "relative",
  //                   fontSize: "10px",
  //                   whiteSpace: "pre-wrap"
  //                 }
  //               },
  //             },
  //             {
  //               type: 'variableText',
  //               name: 'Changelog Entry Content',
  //               props: {
  //                 variable: 'appChangelogEntryContent',
  //                 class: {
  //                   position: "relative",
  //                   paddingTop: "5px",
  //                   paddingBottom: "5px",
  //                   paddingLeft: "0px",
  //                   paddingRight: "0px",
  //                   fontSize: "12px",
  //                   whiteSpace: "pre-wrap"
  //                 }
  //               },
  //             }
  //           ]
  //         }
  //       }
  //     ],
  //   },
  //   propInputs: [
  //     // Variables Panel
  //     'windowHandleVariableInput',
  //     // Container Panel
  //     'positionInput',
  //     'sizeInput',
  //     'positioningInput',
  //     'paddingInput',
  //     'marginInput',
  //     'gapInput',
  //     'overflowInput',
  //     // Style Panel
  //     'containerComboInput',
  //     'effectComboInput',
  //   ],
  // },
};
